import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "field_missions_filter"

// Connects to data-controller="mission-filter"
// Manages mission filter state and persists to localStorage.
// Open/close is delegated to bottom-sheet controller on the same element.
export default class extends Controller {
  static targets = ["badge", "sectorInput", "retailerKindInput", "retailerInput", "clientInput"]
  static values  = { frame: String }

  connect() {
    const saved = this.loadPreference()
    if (saved) {
      const url = new URL(window.location.href)
      const alreadyFiltered = url.searchParams.get("sector_id") ||
                              url.searchParams.get("retailer_kind_id") ||
                              url.searchParams.get("retailer_id") ||
                              url.searchParams.get("client_id")
      if (!alreadyFiltered && (saved.sectorId || saved.retailerKindId || saved.retailerId || saved.clientId)) {
        this.applyFilters(saved.sectorId, saved.retailerKindId, saved.retailerId, saved.clientId)
        return
      }
    }
    this.updateBadge()
  }

  apply() {
    const sectorId       = this.sectorInputTargets.find(el => el.checked)?.value       || ""
    const retailerKindId = this.retailerKindInputTargets.find(el => el.checked)?.value || ""
    const retailerId     = this.retailerInputTargets.find(el => el.checked)?.value     || ""
    const clientId       = this.clientInputTargets.find(el => el.checked)?.value       || ""

    this.savePreference({ sectorId, retailerKindId, retailerId, clientId })

    const sheet = this.application.getControllerForElementAndIdentifier(this.element, "bottom-sheet")
    if (sheet) sheet.close()

    this.applyFilters(sectorId, retailerKindId, retailerId, clientId)
  }

  clearAll() {
    this.savePreference({ sectorId: "", retailerKindId: "", retailerId: "", clientId: "" })

    const sheet = this.application.getControllerForElementAndIdentifier(this.element, "bottom-sheet")
    if (sheet) sheet.close()

    this.applyFilters("", "", "", "")
  }

  applyFilters(sectorId, retailerKindId, retailerId, clientId) {
    const frame = document.getElementById(this.frameValue)
    if (!frame) return

    const url = new URL(window.location.href)

    sectorId       ? url.searchParams.set("sector_id",        sectorId)       : url.searchParams.delete("sector_id")
    retailerKindId ? url.searchParams.set("retailer_kind_id", retailerKindId) : url.searchParams.delete("retailer_kind_id")
    retailerId     ? url.searchParams.set("retailer_id",      retailerId)     : url.searchParams.delete("retailer_id")
    clientId       ? url.searchParams.set("client_id",        clientId)       : url.searchParams.delete("client_id")

    frame.src = url.toString()
    this.updateBadge()
  }

  updateBadge() {
    const url       = new URL(window.location.href)
    const hasFilter = url.searchParams.get("sector_id") ||
                      url.searchParams.get("retailer_kind_id") ||
                      url.searchParams.get("retailer_id") ||
                      url.searchParams.get("client_id")
    if (this.hasBadgeTarget) {
      this.badgeTarget.classList.toggle("hidden", !hasFilter)
    }
  }

  savePreference(data) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
  }

  loadPreference() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) }
    catch { return null }
  }
}
